import classNames from 'classnames';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import apiClient from 'helpers/apiService';
import { ContactData } from 'pages/contacts/components/DataDefinitions';

interface FeedbackFormProps {
  className?: string;
  feedback_type?: string;
  initialData?: any;
  onUpdate: (data: any) => void; // Function to update form data in parent component
}

const FeedbackForm = ({ className, feedback_type, onUpdate, initialData }: FeedbackFormProps) => {

  const { t } = useTranslation();

  const [contacts, setContacts] = useState<ContactData[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchContacts = async () => {
    setLoading(true);
    try {
      const { data } = await apiClient.get('/v1/contacts?skip_picture=true');
      setContacts(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


  // State to store the form data
  const [formData, setFormData] = useState<any>({
    feedback_from: '',
    feedback_to: '',
    feedback_title: '',
    feedback_job_position: '',

  });

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    onUpdate({ ...formData, [name]: value }); // Update the parent component's formData on every change
  };

  // Function to handle select changes
  const handleSelectInputChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //console.log('Selected value:', e.target.value);
    const { name } = e.target;
    //const selectedValues = Array.from(e.target.selectedOptions, (option) => option.value);
    //setFormData({ ...formData, [name]: selectedValues });
    //onUpdate({ ...formData, [name]: selectedValues }); // Update the parent component's formData on every change    
    setFormData({ ...formData, [name]: e.target.value });
    onUpdate({ ...formData, [name]: e.target.value }); // Update the parent component's formData on every change    

  };

  useEffect(() => {
    if (initialData) {
      //console.log('Initial data received:', initialData);
      setFormData({
        feedback_from: initialData['feedback_from'],
        feedback_to: initialData['feedback_to'],
        feedback_title: initialData['feedback_title'],
        feedback_job_position: initialData['job_role']
      });
    }
  }, [initialData]);

  useEffect(() => {
    fetchContacts();
  }, []);

  return (
    <div className={classNames('g-3', className)}>
      <h4 className="mb-3">{t('FeedbackForm.information')}</h4>

      <Row className='mb-2'>
        <Col>
          <FloatingLabel controlId="title" label="Object">
            <Form.Control type="text"
              name='feedback_title' value={formData.feedback_title} onChange={handleInputChange}
            />
          </FloatingLabel>
        </Col>
      </Row>

      {feedback_type === 'receive' && (
        <Row className='mb-2'>
          <Col>
            <FloatingLabel controlId="feedback_from" label="Feedback From">

              <Form.Select required aria-label="Feedback From" name='feedback_from' value={formData.feedback_from} onChange={handleSelectInputChange}>

                {loading && <option>Loading your contacts...</option>}
                {!loading && contacts.length == 0 && <option>No contacts available!</option>}

                {!loading && contacts.length > 0 && (
                  <>
                    <option>Pick a contact to request a feedback</option>
                    {contacts.map((contact, index) => (
                      <option key={index} value={contact.email}>{contact.name}</option>
                    ))
                    }
                  </>
                )}
              </Form.Select>
            </FloatingLabel>
          </Col>
        </Row>
      )}

      {feedback_type === 'given' && (
        <Row className='mb-2'>
          <Col>
            <FloatingLabel controlId="feedback_to" label="Feedback To">
              <Form.Control type="text"
                name='feedback_to' value={formData.feedback_to} onChange={handleInputChange}
              />
            </FloatingLabel>
          </Col>
        </Row>
      )}

      <Row className='mb-2'>
        <Col>
          <FloatingLabel controlId="feedback_job_position" label="Your Job Position">
            <Form.Control type="text" required
              name='feedback_job_position' value={formData.feedback_job_position} onChange={handleInputChange} />
          </FloatingLabel>
        </Col>
      </Row>
    </div>
  );
};

export default FeedbackForm;

